module.exports = __webpack_public_path__ + "img/guide_logo.aa3657ce.png";